import { createRouter, createWebHistory } from 'vue-router'
import HTTPService from '@/services/HTTPService'
import DefaultLayout from '@/layouts/DefaultLayout'
import { TENANTS } from '@/constants/tenants'
//import Chatbot from '@/views/Chatbot.vue'
import ChatbotMain from '@/views/ChatbotMain.vue'
//import ChatbotHome from '@/views/ChatbotHome.vue'
import ChatbotSettingConfirm from '@/views/ChatbotSettingConfirm/Index.vue'
//import Profile from '@/views/Profile.vue'
//import Subscription from '@/views/Subscription.vue'
//import Pricing from '@/views/Pricing.vue'
//import SubscriptionSuccess from '@/views/SubscriptionSuccess.vue'
//import ChatbotHeader from '@/views/ChatbotHeader.vue'
//import FAQ from '@/views/FAQ.vue'
//import Terms from '@/views/Terms.vue'
//import Privacy from '@/views/Privacy.vue'
import Home from '@/views/poc/Home.vue'
import Menu from '@/views/poc/Menu.vue'
import MeetingTranscription from '@/views/poc/MeetingTranscription.vue'
import TextCorrection from '@/views/poc/TextCorrection.vue'
import SearchChat from '@/views/poc/SearchChat.vue'
import MainChat from '@/views/MainChat/Index.vue'
import RagChat from '@/views/RagChat/Index.vue'
import ImageGeneration from '@/views/ImageGeneration/Index.vue'
import Summary from '@/views/Summary/Index.vue'
import TextTranslation from '@/views/TextTranslation/Index.vue'
import OCR from '@/views/OCR/Index.vue'
import Saml2Callback from '@/views/Saml2/Index.vue'
import store from '@/store'
import { useAuthStore } from '@/store/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/service/main-chat',
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/views/Maintenance.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('@/views/register/Register.vue'),
  // },
  // {
  //   path: '/register/success',
  //   name: 'RegisterSuccess',
  //   component: () => import('@/views/register/RegisterSuccess.vue'),
  // },
  // {
  //   path: '/subscribe/success',
  //   name: 'SubscribeSuccess',
  //   component: () => import('@/views/subscribe/SubscribeSuccess.vue'),
  // },
  // {
  //   path: '/unsubscribe',
  //   name: 'Unsubscribe',
  //   component: () => import('@/views/subscribe/Unsubscribe.vue'),
  // },
  //{
  //  path: '/confirm_registration',
  //  name: 'ConfirmRegistration',
  //  component: () => import('@/views/ConfirmRegistration.vue'),
  //},
  // {
  //   path: '/preview',
  //   component: () => import('@/views/history/Preview.vue'),
  // },
  // {
  //   path: '/termandcondition',
  //   component: () => import('@/views/TermAndCondition.vue'),
  // },
  //{
  //  path: '/changepassword',
  //  name: 'ChangePassword',
  //  component: ChangePassword,
  //},
  //{
  //  path: '/reset-password',
  //  name: 'ResetPassword',
  //  component: ResetPassword,
  //},
  //{
  //  path: '/chatbot-dashboard', // add a new route for ChatbotDashboard
  //  name: 'ChatbotDashboard',
  //  component: ChatbotDashboard,
  //},
  //{
  //  path: '/chatbot-step1', // add a new route for ChatbotDashboard
  //  name: 'ChatbotStep1',
  //  component: ChatbotStep1,
  //},
  //{
  //  path: '/step2/:botType',
  //  name: 'ChatbotStep2',
  //  component: ChatbotStep2,
  //  props: true,
  //},
  /*
  {
    path: '/chatbot/:bot_id/:conversation_id',
    name: 'Chatbot',
    component: Chatbot,
    props: (route) => ({
      bot_id: route.params.bot_id,
      conversation_id: route.params.conversation_id,
    }),
  },
  {
    path: '/chatbot/:bot_id',
    name: 'Chatbot',
    component: Chatbot,
    props: (route) => ({
      bot_id: route.params.bot_id,
    }),
  },
  */
  {
    path: '/chatbot-setting',
    name: 'ChatBotSetting',
    component: ChatbotMain,
    props: {
      active: 'ChatbotDashboard',
    },
  },
  {
    path: '/chatbot-setting-confirm',
    name: 'ChatbotSettingConfirm',
    component: ChatbotSettingConfirm,
  },
  /*
  {
    path: '/subscription',
    name: 'Subscription',
    component: Subscription,
    props: true,
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    props: true,
  },
  {
    path: '/subscription_success',
    name: 'SubscriptionSuccess',
    component: SubscriptionSuccess,
    props: true,
  },
  {
    path: '/chatbothome',
    name: 'ChatbotHome',
    component: ChatbotHome,
    redirect: '/service/main-chat',
    props: true,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    props: true,
  },
  {
    path: '/chatbotheader',
    name: 'ChatbotHeader',
    component: ChatbotHeader,
    props: true,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
    props: true,
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    props: true,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    props: true,
  },
  {
    path: '/files/:filename',
    name: 'OpenFile',
    beforeEnter: (to, from, next) => {
      HTTPService.getfile(to.params.filename)
      // Prevent change URL path
      next(false)
    },
  },
  */
  {
    path: '/saml2/callback/:token',
    name: 'Saml2Callback',
    component: Saml2Callback,
    props: true,
  },
  {
    path: '/service',
    component: Home,
    children: [
      {
        path: '',
        name: 'Menu',
        component: Menu,
      },
      {
        path: 'main-chat',
        name: 'MainChat',
        component: MainChat,
      },
      {
        path: 'search-chat',
        name: 'SearchChat',
        component: SearchChat,
      },
      {
        path: 'rag-chat',
        name: 'RagChat',
        component: RagChat,
      },
      {
        path: 'image-generation',
        name: 'ImageGeneration',
        component: ImageGeneration,
      },
      {
        path: 'summary',
        name: 'Summary',
        component: Summary,
      },
      {
        path: 'meeting-transcription',
        name: 'MeetingTranscription',
        component: MeetingTranscription,
      },
      {
        path: 'correction',
        name: 'Correction',
        component: TextCorrection,
      },
      {
        path: 'translation',
        name: 'Translation',
        component: TextTranslation,
      },
      {
        path: 'ocr',
        name: 'OCR',
        component: OCR,
      },
    ],
  },

  {
    path: '/:tenant',
    redirect: (to) => {
      const tenant = to.params.tenant
      const tenantId = TENANTS[tenant]

      // 不正 tenant は弾く
      if (!tenantId) {
        return '/'
      }

      // 正常時のみ rag-chat へ
      return `/${tenant}/service/rag-chat`
    },
  },

  {
    path: '/:tenant/service',
    component: Home,

    beforeEnter: (to, from, next) => {
      const tenant = to.params.tenant
      const tenantId = TENANTS[tenant]

      // 不正 tenant は弾く
      if (!tenantId) {
        return next('/')
      }
      return next()
    },
    children: [
      {
        path: '',
        redirect: { name: 'TenantRagChat' },
      },
      {
        path: 'rag-chat',
        name: 'TenantRagChat',
        component: RagChat,
      },
      {
        path: 'control-panel',
        name: 'TenantControlPanel',
        component: ChatbotMain,
        props: {
          active: 'ChatbotDashboard',
        },
      },
      {
        path: 'control-panel-confirm',
        name: 'TenantControlPanelConfirm',
        component: ChatbotSettingConfirm,
      },
    ],
  },

  {
    path: '/:pathMath(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/'),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router

router.beforeEach(async (to, from, next) => {
  // maintenance start
  //if (to.name !== 'Maintenance') {
  //  return next({ name: 'Maintenance' })
  //}
  //next()
  // maintenance end

  // SAML2のコールバックはそのまま通す
  if (to.name === 'Saml2Callback') return next()

  const auth = useAuthStore()

  try {
    // token 同期待ち（最大300ms）
    if (!auth.token) {
      //requestTokenFromOtherTabs()
      await new Promise((resolve) => setTimeout(resolve, 300))
    }
    const token = auth.token
    //const token = StorageService.getToken()
    // トークンがない → ログイン画面へ（Login画面以外の場合）
    if (!token) {
      // 未ログインで、Login以外をリクエストした場合は保存
      if (to.name !== 'Login') {
        localStorage.setItem('redirectAfterLogin', to.fullPath)
      }
      return to.name === 'Login' ? next() : next('/login')
    }

    // トークンがある → ユーザー取得試行
    const response = await HTTPService.getuser()
    const data = response.data

    if (data.success === true) {
      store.commit('updateUserId', response.data.userId)
      store.commit('updateEmail', response.data.email)
      //localStorage.setItem('token', response.data.token)
      auth.setToken(response.data.token)

      // リダイレクト先が保存されていればそこに戻す
      const redirectPath = localStorage.getItem('redirectAfterLogin')
      if (redirectPath) {
        localStorage.removeItem('redirectAfterLogin')
        return next(redirectPath)
      }

      // 通常の遷移
      return to.name === 'Login' ? next('/service/main-chat') : next()
    } else {
      // ユーザー取得失敗 → ログイン画面へ
      auth.clear()
      return next('/login')
    }
  } catch (e) {
    console.error('認証チェックでエラー:', e)
    // ユーザー取得失敗 → ログイン画面へ
    auth.clear()
    //StorageService.clearToken()
    return next('/login')
  }
})
